<template>
  <div id="user-appointments">
    <!-- <DIALOGS> -->
    <!-- <REPORT LIST DIALOG> -->
    <v-dialog v-model="reportDialog" max-width="790">
      <reports-list
        @closeModal="reportDialog = false"
        :appointmentId="selectedAppointment"
      ></reports-list>
    </v-dialog>
    <!-- </REPORT LIST DIALOG> -->
    <!-- <FILTER DIALOG> -->
    <v-dialog v-model="filterDialog" max-width="790">
      <admin-filter
        @closeModal="filterDialog = false"
        @filterAppointments="filterAppointments"
        @resetSelectedPage="resetSelectedPage"
        :filterType="selectedFilter"
        :dialog="filterDialog"
      ></admin-filter>
    </v-dialog>
    <!-- </FILTER DIALOG> -->
    <!-- <DELETE APPOINTMENTS DIALOG> -->
    <v-dialog
      v-model="deleteAppointmentsDialog"
      max-width="790"
      style="overflow: visible"
    >
      <delete-appointments></delete-appointments>
    </v-dialog>
    <!-- </DELETE APPOINTMENTS> -->
    <!-- </DIALOGS> -->
    <!-- <HEADER> -->
    <div class="header">
      <div class="clear-filter" v-if="clearFilteredData" @click="resetData">
        Očisti filtrirane rezultate
      </div>

      <!-- <APPOINTMENTS BY TODAY TOGGLE> -->
      <div class="header-left-side">
        <div class="appointments-by-today-toggle">
          <label v-if="!clearFilteredData" class="switch">
            <input type="checkbox" checked @click="filterAppointmentsByToday" />
            <span class="slider round"></span>
          </label>
          <p
            v-if="appointmentsToggle == true && !clearFilteredData"
            style="display:inline-block"
          >
            Održani termini
          </p>
        </div>
        <v-checkbox
          :label="'Termini bez izvještaja'"
          v-model="showAppointmentsWithouthReport"
          @change="toggleAppointmentsWithoutReport"
        ></v-checkbox>
      </div>
      <!-- </APPOINTMENTS BY TODAY TOGGLE> -->
      <!-- <FILTER> -->
      <v-menu open-on-hover bottom offset-y style="float:right;">
        <img
          class="action-icon-lg"
          slot="activator"
          src="../../../assets/icons/filter.png"
          alt
        />
        <v-list>
          <v-list-tile
            v-for="(item, index) in filterSelector"
            :key="index"
            @click="openFilterDialog(item.value)"
          >
            <v-list-tile-title>
              <span>{{ item.text }}</span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- </FILTER> -->
    </div>
    <!-- </APPOINTMENTS> -->
    <v-container>
      <v-data-table
        :headers="headers"
        :items="appointments"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr
            :class="{
              'one-day-overdue': props.item.oneDayPassed,
              'five-days-overdue': props.item.fiveDaysPassed,
              'seven-days-overdue': props.item.sevenDaysPassed,
            }"
          >
            <td class="text-xs-left">{{ props.item.Date }}</td>
            <td class="text-xs-left">{{ props.item.Time }}</td>
            <td class="text-xs-left">{{ props.item.AppointmentType }}</td>
            <td class="text-xs-left">{{ props.item.Studio }}</td>
            <td class="text-xs-center">
              <img
                v-if="!props.item.IsReported"
                @click="openReportDialog(props.item.AppointmentId)"
                class="action-icon-sm"
                src="../../../assets/icons/report.png"
                alt="Report"
              />
              <img
                v-if="props.item.IsReported"
                @click="openReportDialog(props.item.AppointmentId)"
                class="action-icon-sm"
                src="../../../assets/icons/report-edit.png"
                alt="Report"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>

    <!-- <PAGINATION> -->
    <div class="text-xs-center pagination">
      <v-pagination
        :total-visible="5"
        @input="getAppointments"
        v-model="selectedPage"
        :length="numberOfPages"
      ></v-pagination>
    </div>
    <!-- </PAGINATION> -->
  </div>
</template>

<script>
import ReportsList from "../../Reports/List";
import AdminFilter from "./AdminFilter";
import DeleteAppointments from "../DeleteAppointments";
import { formatAppointments } from "../../../helpers";

export default {
  components: {
    reportsList: ReportsList,
    adminFilter: AdminFilter,
    deleteAppointments: DeleteAppointments,
  },
  data() {
    return {
      appointments: [],
      selectedAppointment: null,
      reportDialog: false,
      filterDialog: false,
      deleteAppointmentsDialog: false,
      selectedFilter: null,
      clearFilteredData: false,
      //For displaying only past appointmets
      appointmentsToggle: true,
      showAppointmentsWithouthReport: false,

      //Data table headers
      headers: [
        {
          text: "Datum termina",
          value: "datum",
          align: "left",
        },
        {
          text: "Vrijeme",
          value: "vrijeme",
          align: "left",
        },
        {
          text: "Vrsta termina",
          value: "vrstaTermina",
          align: "left",
        },
        {
          text: "Studio",
          value: "studio",
          align: "left",
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "center",
        },
      ],
      //Pagination
      numberOfPages: 1,
      selectedPage: 1,

      //Filter selector
      filterSelector: [
        {
          text: "Datum",
          value: "date",
          icon: "date_range",
        },
        {
          text: "Studio",
          value: "studio",
          icon: "date_range",
        },
        {
          text: "Tip termina",
          value: "appointmentType",
          icon: "date_range",
        },
        {
          text: "Brisanje termina",
          value: "appointmentDelete",
          icon: "date_range",
        },
      ],
      filterObject: null,
    };
  },
  methods: {
    getAppointments() {
      if (this.selectedFilter == null) {
        this.getAllAppointments();
      } else {
        this.filterAppointments();
      }
    },
    getAllAppointments() {
      //If appointmentsToggle is true actions should return only appointments that ended by todays date
      this.$store.state.services.appointmentService
        .getForAdmin(this.selectedPage, this.appointmentsToggle, this.showAppointmentsWithouthReport)
        .then((result) => {
          this.appointments = formatAppointments(result.data.Appointments);
          this.numberOfPages = result.data.NumberOfPages;
        })
        .catch((err) => {});
    },
    filterByDate(date) {
      this.$store.state.services.appointmentService
        .adminListByDate(this.selectedPage, date, this.showAppointmentsWithouthReport)
        .then((result) => {
          this.appointments = formatAppointments(result.data.Appointments);
          this.numberOfPages = result.data.NumberOfPages;
        })
        .catch((err) => {});
    },
    filterByStudio(studioId) {
      this.$store.state.services.appointmentService
        .adminListByStudio(this.selectedPage, studioId, this.showAppointmentsWithouthReport)
        .then((result) => {
          this.appointments = formatAppointments(result.data.Appointments);
          this.numberOfPages = result.data.NumberOfPages;
        })
        .catch((err) => {});
    },
    filterByAppointmentType(appointmentTypeId) {
      this.$store.state.services.appointmentService
        .adminListByAppointmentType(this.selectedPage, appointmentTypeId, this.showAppointmentsWithouthReport, this.showAppointmentsWithouthReport)
        .then((result) => {
          this.appointments = formatAppointments(result.data.Appointments);
          this.numberOfPages = result.data.NumberOfPages;
        })
        .catch((err) => {});
    },
    openReportDialog(appointmentUsersId) {
      this.selectedAppointment = appointmentUsersId;
      this.reportDialog = true;
    },
    openFilterDialog(filterType) {
      if (filterType === "appointmentDelete") {
        this.deleteAppointmentsDialog = true;
        return;
      }
      this.filterDialog = true;
      this.selectedFilter = filterType;
    },
    filterAppointments(filter) {
      if (filter != undefined) {
        this.filterObject = filter;
      }
      this.filterDialog = false;
      if (this.selectedFilter == "date") {
        this.filterByDate(this.filterObject.selectedDate);
      } else if (this.selectedFilter == "studio") {
        this.filterByStudio(this.filterObject.selectedStudio);
      } else {
        this.filterByAppointmentType(this.filterObject.selectedAppointmentType);
      }
      this.clearFilteredData = true;
    },
    filterAppointmentsByToday() {
      this.appointmentsToggle = !this.appointmentsToggle;
      this.getAllAppointments();
    },
    resetData() {
      this.selectedPage = 1;
      this.selectedFilter = null;
      this.clearFilteredData = false;
      this.appointmentsToggle = true;
      this.getAppointments();
    },
    resetSelectedPage() {
      this.selectedPage = 1;
    },
    toggleAppointmentsWithoutReport() {
      this.resetSelectedPage();
      this.getAppointments();
    }
  },
  created() {
    this.getAppointments();
  },
  watch: {
    filterDialog() {
      if (this.filterDialog == false) {
        // this.selectedFilter = null;
      }
    },
  },
};
</script>

<style scoped>
#user-appointments {
  padding-bottom: 40px;
}
.pagination {
  position: absolute;
  bottom: 0;
  margin: 30px 0;
  width: 100%;
}
.appointments-by-today-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-left-side {
  display: flex;
  align-items: center;
  gap: 20px;
}
.appointments-by-today-toggle p {
  margin: 0;
}
</style>
